import { REGISTER_ERROR, REGISTER_REQUEST, REGISTER_SUCCESS } from "../../constants";

const initialState = {
  data: '',
  isLoading: false,
  error: '',
}


export default function (state = initialState, action) {
  switch (action.type) {
    case REGISTER_REQUEST:
      return { ...state, data: '', isLoading: action.loading, error: '' }
    case REGISTER_SUCCESS:
      return { ...state, data: action.payload, isLoading: false, error: '' }
    case REGISTER_ERROR:
      return { ...state, data: '', isLoading: false, error: action.error }
    default:
      return state;
  }
}

